package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import js.core.jso
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.sender.common.models.Sender
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError


external interface SenderContextInterface {
    var list: List<Sender>
    var currentSender: Sender
    var setCurrentId: (String) -> Unit
}

val SenderContext = createContext<SenderContextInterface>(jso {
    list = emptyList()
    currentSender = Sender("", "", "")
    setCurrentId = {}
})

val SenderProvider = FC<PropsWithChildren> { props ->
    val backDrop = useBackdrop()
    val store = useStore().currentStoreId

    var list by useState<List<Sender>>(emptyList())
    var currentSender by useState(Sender("", store.orEmpty(), ""))

    useEffect(store) {
        if (store.isNullOrBlank())
            return@useEffect

        backDrop.show()
        Http.get("/senders", mapOf("store" to store)) { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            val result = response.body<List<Sender>>()
            list = result
            if (result.isNotEmpty()) {
                currentSender = result.first()
            }
            backDrop.hide()
        }
    }

    SenderContext.Provider {
        value = jso {
            this.list = list
            this.currentSender = currentSender
            this.setCurrentId = { id -> currentSender = list.find { it.id == id } ?: Sender("", store.orEmpty(), "") }
        }
        +props.children
    }
}

fun useSender() = useContext(SenderContext)